import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
} from '../../../../../../../../../components/TableContent';
import { useGlobalAssetContext } from '../../../../../contexts';
import { ButtonSkeleton, TextSkeleton } from '../../../../AssetsLoading';
import { LateralBar } from '../../../components/LateralBar';
import { clubsConstants } from '../constants';

export const ListLoadingItemDesktop: React.FC = () => {
  const { selectedTab } = useGlobalAssetContext();

  const getFlex = (index: number) => {
    const currentHead = clubsConstants.tableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <TableContent direction="row" space={0} p={0} px="inline.xxxs" h="80px">
      <LateralBar
        backgroundColor={selectedTab.color}
        borderTopLeftRadius="sm"
        borderBottomLeftRadius="sm"
      />
      <TableContentItemColumn flex={getFlex(1)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <ButtonSkeleton />
      </TableContentItemColumn>
    </TableContent>
  );
};
